class Form {
  constructor(form) {
    this.form = form;
    this.inputs = Array.from(this.form.elements);
  }

  floatLabels() {
    this.inputs.forEach((input) => {
      this.setHasValue(input);

      input.addEventListener('input', (e) => {
        this.setHasValue(input);
      });
    });
  }

  setHasValue(input) {
    if (input.value !== '') {
      input.classList.add('js-has-value');
    } else {
      input.classList.remove('js-has-value');
    }
  }
}

export default Form;



// WEBPACK FOOTER //
// ./assets/js/modules/form.js